<template>
  <div :class="alertClass" class="alert">
    <p v-if="title" class="h4 alert-heading mb-1">{{ title }}</p>
    <div class="alert-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Alert",
  props: {
    variant: {
      type: String,
      required: false,
      default: "",
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
  },
  computed: {
    alertClass() {
      switch (this.variant) {
        case "success":
          return "alert-success";
        case "danger":
          return "alert-danger";
        case "warning":
          return "alert-warning";
        case "info":
          return "alert-info";
        default:
          return "alert-secondary";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.alert-body p:last-of-type {
  margin-bottom: 0;
}

.alert-heading {
  color: inherit;
}

.alert {
  margin-bottom: 0;
}
</style>
